import { InputAddon, InputCurrency, InputGroup } from '../../../../../../../components';
import { canEditOfferDiscountPercentage } from '../../../../store/offer-store';
import { useOfferInlineEdit } from './hooks/useOfferInlineEdit';
import type { IRowData } from './OfferTable';
import styles from './OfferTable.module.scss';

interface OfferDiscountCellProps {
  rowData: IRowData;
  campaignId: string;
  disabled?: boolean;
}

export const OfferDiscountCell = ({ rowData, campaignId, disabled = false }: OfferDiscountCellProps) => {
  const { localDiscount, onDiscountChange, onDiscountBlur } = useOfferInlineEdit(rowData, campaignId);

  return (
    <InputGroup className={styles['input-addon-gray']}>
      <InputCurrency
        value={localDiscount}
        decimalSeparator=","
        thousandSeparator="."
        precision="1"
        allowEmpty
        allowNegative={false}
        disabled={disabled || !canEditOfferDiscountPercentage(rowData.offer_dto?.offer?.offer_type)}
        onChangeEvent={(_e: unknown, _m: unknown, v: number | null) => onDiscountChange(v)}
        onBlur={onDiscountBlur}
      />
      <InputAddon>% off</InputAddon>
    </InputGroup>
  );
};
